import { Button, Inline } from '@omnipresentgroup/design-system';
import type { InvoiceReport } from '@omnipresentgroup/types';
import { useState } from 'react';

import {
  InvoiceReportPayActions,
  InvoiceReportRowActions,
} from '../../../../features/invoice-reports';
import { useManagerUser } from '../../../../hooks';
import { WrappedMixpanel } from '../../../../mixpanelWrapper';
import { InvoiceReportApproveModal } from './InvoiceReportApproveModal';

const APPROVE_INVOICE = 'Approve invoice';

type Props = {
  invoice: InvoiceReport;
};

export const InvoiceReportActions = ({ invoice }: Props) => {
  const [openModal, setOpenModal] = useState<boolean>(false);

  const { companyId, userId } = useManagerUser();

  return (
    <>
      <Inline gap="16" align="center" css={{ flexWrap: 'wrap' }}>
        <InvoiceReportRowActions
          invoice={invoice}
          withSelectableAction
          variant="secondary"
        />
        {invoice.approved !== null && Boolean(invoice.approved) === false && (
          <Button
            variant="primary"
            onClick={() => {
              WrappedMixpanel.track('Approve Invoice Clicked', {
                companyId,
                userId,
                invoiceId: invoice.id,
                memo: invoice.reference,
              });
              setOpenModal(true);
            }}
          >
            {APPROVE_INVOICE}
          </Button>
        )}
        <InvoiceReportPayActions invoice={invoice} />
      </Inline>
      {openModal && invoice && (
        <InvoiceReportApproveModal
          open={openModal}
          closeFn={() => setOpenModal(false)}
          invoice={invoice}
        />
      )}
    </>
  );
};
